import { render, staticRenderFns } from "./PurchaseOverview.vue?vue&type=template&id=0df01814"
import script from "./PurchaseOverview.vue?vue&type=script&lang=js"
export * from "./PurchaseOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports